import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * News Routes and Pages
 */
const ListFeaturesPage = React.lazy(() => import("./ListFeaturesPage"));
const AddFeaturesPage = React.lazy(() => import("./AddFeaturesPage.js"));
const EditFeaturesPage = React.lazy(() => import("./EditFeaturesPage"));

const FeaturesRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListFeaturesPage />} />
      <Route exact path="/add" element={<AddFeaturesPage />} />
      <Route exact path="/edit/:id" element={<EditFeaturesPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default FeaturesRoutes;
